import { apiRequest } from '@/core';
import { type UserLogin } from '@/types';

export const forgotPasswordRequest = async (user: Pick<UserLogin, 'email'>) =>
  apiRequest<void>({
    endpoint: 'forgot-password',
    body: user,
  });
